module.exports = __webpack_public_path__ + "static/media/سیستم-سورتینگ.4dc2367f.jpg";